/**
 * Settings schemas — per-tenant integration configuration.
 */
import { z } from "zod";
/** GET /settings/twilio response */
export const TwilioSettingsResponseSchema = z.object({
    configured: z.boolean(),
    from_number: z.string().nullable(),
    webhook_sms_url: z.string(),
    webhook_voice_url: z.string(),
});
/** PUT /settings/twilio request */
export const UpdateTwilioSettingsRequestSchema = z.object({
    account_sid: z.string().min(1, "Account SID is required"),
    auth_token: z.string().min(1, "Auth Token is required"),
    from_number: z
        .string()
        .regex(/^\+[1-9]\d{1,14}$/, "From number must be E.164 format (e.g. +15551234567)"),
});
/** GET /settings/booking response */
export const BookingLinkResponseSchema = z.object({
    booking_url: z.string().nullable(),
});
/** PUT /settings/booking request */
export const UpdateBookingLinkRequestSchema = z.object({
    booking_url: z
        .string()
        .url("Must be a valid URL (e.g. https://calendly.com/yourname)")
        .nullable(),
});
//# sourceMappingURL=settings.js.map